import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '../../utils/Toggle';

export default class ToggleAddon extends React.PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
      .isRequired,
    modifyChild: PropTypes.func,
  };

  static defaultProps = {
    modifyChild: null,
  };

  modifyChild = child => {
    if (!child) {
      return null;
    }

    const { modifyChild } = this.props;
    return modifyChild ? modifyChild(child) : child;
  };

  render() {
    const { children } = this.props;
    return (
      <Toggle isFilterBar>
        <Toggle.OnContent>
          {React.Children.map(children, this.modifyChild)}
        </Toggle.OnContent>
      </Toggle>
    );
  }
}
